export default __webpack_public_path__ + "static/media/plantel.5cb5e818.jpg";